import type { GetMarketingResponse } from './types';

import { getGenericEndpoint } from './get.api';

export const getMarketing = async (lang = 'en') => {
    return await getGenericEndpoint<GetMarketingResponse>('marketing', lang);
};
